import { render, staticRenderFns } from "./GoodsServices.vue?vue&type=template&id=1d0bcb76&scoped=true&"
import script from "./GoodsServices.vue?vue&type=script&lang=js&"
export * from "./GoodsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0bcb76",
  null
  
)

export default component.exports